{
    "releaseNotes": {
        "tabName": "Releasegeschiedenis",
        "accordianHeading": "Release me@eon V<version>",
        "accordianMyHelpHeading": "Release MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Release MyHelp V<version>",
        "whatsNew": "Wat is nieuw",
        "tipsAndTricks": "Tips en trucs",
        "faq": "FAQ"
    },
    "ourTeam": {
        "tabName": "Ons team",
        "keyMembers": "Belangrijke leden"
    },
    "featureRoadmap": {
        "tabName": "Functies & Routekaart"
    }
}